import {Button, Modal} from "react-bootstrap";
import SuccIcon from "../../../images/deblockIcon.svg";
import EcheccIcon from "../../../images/blockIcon.svg";

const modalStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex", // Enables flexbox
    justifyContent: "center", // Centers horizontally
    alignItems: "center", // Centers vertically
    zIndex: 1051,
  },
};

const BlockModal = ({
  show,
  setShow,
  success,
  title,
  message,
  handleButton,
  buttonTitle,
  openListBlock,
}) => {
  return (
    <Modal
      className="modal fade"
      show={show}
      style={modalStyles}
      onHide={() => {
        setShow(false);
        !!openListBlock && openListBlock(true);
      }}
      centered
    >
      <div className="modal-content">
        <div className="modal-header !border-none">
          <Button
            variant=""
            type="button"
            className="close"
            data-dismiss="modal"
            onClick={() => {
              setShow(false);
              !!openListBlock && openListBlock(true);
            }}
          >
            <span>×</span>
          </Button>
        </div>
        <div className="modal-body !p-2">
          <div className=" flex flex-col gap-2 justify-center items-center !px-12 ">
            {!!success ? (
              <>
                <img src={SuccIcon} alt="ToastIcon" className="w-16 !mb-4" />
                <div className="text-[#2EBD04] font-bold text-xl text-center !px-3">
                  {title}
                </div>

                <div className="text-[#19295C] text-center font-semibold text-sm !px-3">
                  {message}
                </div>
              </>
            ) : (
              <>
                <img src={EcheccIcon} alt="ToastIcon" className="w-16 !mb-4" />
                <div className="text-[#FF0000] font-bold text-xl text-center !mb-1">
                  {title}
                </div>

                <div className="text-[#19295C] text-center font-semibold text-sm ">
                  {message}
                </div>
              </>
            )}
            <div className="flex gap-4 items-center w-full !mt-4 mb-3 ">
              <button
                onClick={() => {
                  setShow(false);
                  !!openListBlock && openListBlock(true);
                }}
                type="button"
                className="!rounded-md w-1/2  bg-white  !py-3 text-[#1A64B9] !border !border-[#1A64B9] font-medium text-sm "
              >
                Annuler
              </button>
              <button
                onClick={handleButton}
                type="button"
                className="!rounded-md w-1/2   !py-3 text-white bg-gradient-to-r from-[#0022AA] to-[#1A64B9] font-medium text-sm    "
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default BlockModal;
